"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var debug = require("debug");
exports.default = debug('sanity');
//# sourceMappingURL=debug.js.map